module.exports = __webpack_public_path__ + "img/flower-1.2c653e13.png";